module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURUdwTNDAR9DAR9DAR9DAR9DAR9DAR9DAR9DAR/nQ2bwAAAAIdFJOUwDLbO8YOaSNSzoh4AAAAAlwSFlzAAAASAAAAEgARslrPgAAAHlJREFUGNNjYGAS7gADQwUGBhaJDihodGBg7IADAQYNBKeJAayqvQKsjgEslsAGphggQhAFYI4IA4MjjNPsALTBAsoxZQCCYCgnAMRhhXCaGMBAA8xRgHCYIMognA6sHIlGJA4E4+Y0g1wYwArBjaieQ/E2SoAgBxUAVRZo6C1nRUMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/school/property.png
// module id = 219
// module chunks = 0